import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import SurveyListHeader from "../../../component/layout/MainHeader";
import Input from "../../../core/Inputs/DefaultInput";
import { toast } from 'react-toastify';
import './profile.css';
import * as Yup from "yup";
import Button from "../../../core/Button";
import AccountSettingSidebar from "./components/AccountSettingSidebar";
import SurveyListSidebar from "../../../component/layout/MainSidebar";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import NestedMenuToggle from "./NestedMenuToggle";
import { addSetting, getSettingList} from "../../../store/actions/settingAction";
//import nodemailer from 'nodemailer';

const AwsSchema = Yup.object().shape({
  puppeteerConfig: Yup.string().required("Puppeteer config is required")
});

export default function Smtp() {
  const dispatch = useDispatch();
  const { settingData } = useSelector((state) => state.settingData);

  const [formValue, setFormValue] = useState({
    puppeteerConfig: ""
  });

  const handleSubmit = (values) => {
    dispatch(addSetting(values));
    handleGetSettingList(); 
  };
  const handleGetSettingList = () => {
    let payload = {
      tag: 'puppeteer',
    };
    dispatch(getSettingList(payload));
  }

  useEffect(() => {
    handleGetSettingList();
  }, [])

  const getPuppeteerConfig = (selector) => {
    const config = {};
    selector.forEach(item => {
      switch (item.type) {
        case 'puppeteerConfig':
          config.puppeteerConfig = item.value;
        default:
          break;
      }
    });
    return config;
  };
  const smtpConfig = useCallback(getPuppeteerConfig(settingData), [settingData]);
  useEffect(() => {
    setFormValue(smtpConfig);
  }, [smtpConfig]);
  // const smtpConfig = getSMTPConfig(settingData);
  // setFormValue(smtpConfig); 
  //console.log("smtpConfigformValue",formValue)
  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
        <SurveyListHeader />
        <div id="viewport" className="d-flex">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <AccountSettingSidebar />
            <div className="flex-grow-1 variable-pg-content">
              {/* breadcrumbs here */}
              <div className="custom-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      Home
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/profile">Settings</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      <strong>Puppeteer settings</strong>
                    </li>
                  </ol>
                </nav>
              </div>
              {/* breadcrumbs ends here */}
              <div className="survey-main-container">
                <div className="page-heading d-lg-none">
                  <div className="d-flex align-items-start">
                    <NestedMenuToggle />
                    <div className="flex-grow-1 ps-3 ps-lg-0">
                      <h1>Account settings</h1>
                    </div>
                  </div>
                </div>
                <div className="pagesRow varPg">
                  <div className="profile-wrapper">
                    <div className="account-info border-0 pb-0">
                      <Formik
                        initialValues={formValue}
                        enableReinitialize
                        validationSchema={AwsSchema}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                          handleSubmit(values);
                          setSubmitting(false);
                          resetForm();
                          toast.success("Settings saved successfully");
                        }}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting,
                        }) => (
                          <form onSubmit={handleSubmit}>
                            <div className="form-wrapper custom-width">
                              <div className="row gx-12px">
                                <div className="col-lg-12 position-relative">
                                  <div className="mb-3">
                                    <label htmlFor="awsAccessKey">Puppeteer config</label>
                                    <Input
                                      type="text"
                                      view="outlined"
                                      dense={false}
                                      color="default"
                                      placeholder="puppeteer Config"
                                      clearButton={true}
                                      success={false}
                                      error={errors.puppeteerConfig && touched.puppeteerConfig}
                                      fill={true}
                                      className={"formsinput"}
                                      name="puppeteerConfig"
                                      value={values.puppeteerConfig}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors.puppeteerConfig && touched.puppeteerConfig && (
                                      <div className="validation-msg">
                                        {errors.puppeteerConfig}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                
                              </div>
                              <div className="btn-wrap">
                                <button
                                  className={"formsbutton btn-bordered btn mb-0"}
                                  type="submit"
                                  view="outlined"
                                  color="primary"
                                  disabled={isSubmitting}
                                >
                                  Save changes
                                </button>
                              </div>

                            </div>
                          </form>
                        )}
                      </Formik>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
